import { CaseInformationNewMexico } from './CaseInformationNewMexico';

export default CaseInformationNewMexico;
